// extracted by mini-css-extract-plugin
export default {"container":"_1R57YC","content":"_3nwcS8","contentWrapper":"_31doc2"};